import React, { Component } from "react";
import { withStyles, Button, Drawer, Badge, CircularProgress, Modal, Menu, MenuItem, Snackbar } from "@material-ui/core";
import EmailOutlinedIcon from "@material-ui/icons/EmailOutlined";
import { styles } from "./Messages.css";
import { connect } from "react-redux";
import Messages from "./Messages";
import { BiBookContent } from "react-icons/bi";
import {
  setNewCount,
  setUnreadCount,
  editMessage,
  setEditMessageCB,
  closeMessageCB,
  postMessage,
  setQuery,
  selectItems,
  focusItem,
  search,
  setMessageAsRead,
  updateContentReqStatus,
  validateCR,
  setUsePopup,
  sharedPlaylistRequest,
  setPlaylistPermittedOrgs,
  redirectMessageClose
} from "./redux/MessagesActions";
import { removeHistory } from "../ml-content-tracker/content-request/redux/ContentRequestActions";
import { getAllUsers, getAllGroups } from "../../redux/actions/InboxActions";
import * as realTimeSubscription from "../../data-services/realTimeSubscription";
import {cloudClose as  cloudCloseTrack } from "../../redux/actions/MlTrackLibraryActions"
import {cloudClose as  cloudCloseAlbum } from "../../redux/actions/MlAlbumActions"
import {withRouter} from 'react-router-dom';
import PermittedContent from "../../_module/component/permitted-content/PermittedContent";
import { BiMessageAdd, BiMessageDetail, BiMessageAltCheck } from "react-icons/bi";
import { _newMessage } from "./Utils";
import { messageTypes, } from "./Const";
import ContentRequest from "./ContentRequest";
import clsx from "clsx";


class MessagesWrap extends Component {
  messageSubscripition;
  messageGroupSubscripition = [];
  totalUnread = 0;
  constructor(props) {
    super();
    this.state = {
      open: false,
      anchorEl: null,
      ContentRequestDialogOpen: false,
      showUnreadOnly: false
    };
    this.setOpen = this.setOpen.bind(this);
  }

  setOpen() {
    this.handleOpen();
  }

  handleOpen = () => {
    const { setUsePopup, editMessage } = this.props;
    setUsePopup(false);
    this.closeTagCloud();
    editMessage(null);
    this.setState({
      open: true,
      anchorEl: null,
      showUnreadOnly: false
    });
  };

  handleOpenUnread = () => {
    const { setUsePopup, editMessage } = this.props;
    setUsePopup(false);
    this.closeTagCloud();
    editMessage(null);
    this.setState({
      open: true,
      anchorEl: null,
      showUnreadOnly: true
    });
  };

  closeTagCloud() {
    const { 
      cloudCloseTrack ,cloudCloseAlbum
    } = this.props;
    cloudCloseTrack();
    cloudCloseAlbum();
  }

  handleClose = () => {
    const { setUsePopup, redirectMessageClose } = this.props;
    setUsePopup(false);
    redirectMessageClose();
    this.setState({ open: false, showUnreadOnly: false });
  };

  getMessageList = () => {
    const {
      search: messageSearch,
      messages: { query },
      setQuery
    } = this.props;

    let newQuery = { ...query, page: 0}
    setQuery(newQuery);
    messageSearch(newQuery);
    // messageSearch({ ...query, page: 0 });
    // messageSearch({ ...query });

  }


  componentDidMount() {
    const { user, inbox:{allUsers, loadingUsers}, getAllUsers,setPlaylistPermittedOrgs } = this.props;

    this.props.setOpen(this.setOpen);

    setPlaylistPermittedOrgs();
    if (!loadingUsers && !allUsers?.length) {
      getAllUsers();
    }

    const { inbox:{allGroups, loadingGroups}, getAllGroups } = this.props;
    if (!loadingGroups && !allGroups?.length) {
      getAllGroups();
    }

    const {
      search: messageSearch,
      messages: { query },
    } = this.props;

    messageSearch({ ...query, page: 0 });

    if(user?.credentials?.orgs[0]?.groups?.length){
      let userGroups = user.credentials.orgs[0].groups;
      try {
        this.messageGroupSubscripition =  userGroups.map((group) =>{
         return realTimeSubscription.subscribe(
            { groupId: group, type:"group", topic: realTimeSubscription.Topics.MESSAGES }, 
            this.getMessageList
            );
        });
      } catch (error) {
         console.log(error);
      }
    }

    try {
      this.messageSubscripition =  realTimeSubscription.subscribe({ userId: this.props.user.email.trim(), type:"user", topic: realTimeSubscription.Topics.MESSAGES }, this.getMessageList);
    }
    catch (error) {
      console.log(error);
    };
  }

  componentWillUnmount() {
    if(this.messageSubscripition) this.messageSubscripition();
    if(this.messageGroupSubscripition.length){
      this.messageGroupSubscripition.forEach(mSubscripition => {
        mSubscripition();
      });
    }
  };

  hasseen = (m) => {
    const {
      user: { id: userid },
    } = this.props;

    return m.seenusers && m.seenusers.includes(userid);
  };

  handleMenuOpen = (event) => this.setState({ anchorEl: event.currentTarget });
  handleMenuClose = () => this.setState({ anchorEl: null });

  onContentRequestClick = (event) => {
    this.handleMenuClose();
    this.setState({ ContentRequestDialogOpen: true });
  };

  handleCloseContDialog = () => {
    this.setState({ ContentRequestDialogOpen: false, anchorEl: null });
  };

  newMessage = () => {
    const { editMessage } = this.props;
    this.handleMenuClose();
    this.setState({
      open: false,
    },()=>{
      editMessage(_newMessage(messageTypes.TEXT, [], "New message"));
    });
  };

  setAsRead = () => {
    const { setMessageAsRead } = this.props;
    setMessageAsRead((data, error)=>{
      if(error){
        
      }
      else{
        this.handleMenuClose();
      }
      
    });
  }

  render() {
    const {
      classes,
      messages: { editing,loading, items, totalUnread, usePopup, settingAsRead, redirectMessageOpen, plReqPosting :{busy : plShareBusy, message}},
      orgRuntime,
      orgRuntime: {
        runtime: {
          _Messages, _canCreateContentRequest
      
        }
      } 
    } = this.props;

    const { anchorEl, ContentRequestDialogOpen, showUnreadOnly } = this.state;

    const getNewCount = () =>{
      let newCount = 0;
      items.forEach(v=> { 
         if (!this.hasseen(v))
          newCount = newCount+1;
      })

      // return newCount;
      return this.totalUnread =  (totalUnread !== undefined) ? totalUnread : this.totalUnread;
    }

    return (
      <>
            <Snackbar
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              open={ (plShareBusy && message)  ? true : false
              }
              message={ message }
              className={classes.snackbar}
            />

        {ContentRequestDialogOpen && 
          <ContentRequest
            DialogOpen={ContentRequestDialogOpen}
            classes={classes}
            DialogClose={this.handleCloseContDialog}
            {...this.props}
          /> 
        }
        <Button 
          title="Messages" 
          aria-label="Messages" 
          onClick={this.handleMenuOpen}
        >
          <Badge
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            badgeContent={getNewCount()}
            color="secondary"
          >
            {!loading && <EmailOutlinedIcon title="Messages" />}
            {loading && !this.props.cfId && <CircularProgress className={classes.circularProgressIcon} />}
          </Badge>
        </Button>

        <Menu
          keepMounted
          getContentAnchorEl={null}
          anchorOrigin={{
            horizontal: "left",
            vertical: "bottom",
          }}
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleMenuClose}
        >
          <MenuItem
            key={"inbox"}
            title={"View inbox"}
            onClick={this.handleOpen}
          >
            <EmailOutlinedIcon className={classes.actionMenuIcon} />  Inbox
          </MenuItem>
          <MenuItem
            key={"newMessage"}
            title={"Create Message"}
            onClick={this.newMessage}
          >
            <BiMessageAdd className={classes.actionMenuIcon} />   Create Message
          </MenuItem>
          {/* <PermittedContent
            modulePath={[_Messages, _canCreateContentRequest]}
          >
          <MenuItem
            key={"newContentReq"}
            title={"Create Content Request"}
            onClick={this.onContentRequestClick}
          >
            <BiBookContent className={classes.actionMenuIcon} /> Create Content Request
          </MenuItem>
          </PermittedContent> */}
          <MenuItem
           key={"viewAllUnreadMessages"}
           title={"View All Unread Messages"}
            onClick={this.handleOpenUnread}
            disabled={getNewCount() == 0? true : null}
          >
            <BiMessageDetail className={classes.actionMenuIcon} />   View All Unread Messages
          </MenuItem>
          <MenuItem
            key={"markasViewedAllUnreadMessages"}
            title={"Mark  All Unread Messages as Read"}
            onClick={this.setAsRead}
            disabled={getNewCount() == 0? true : null}
          >
            <BiMessageAltCheck className={classes.actionMenuIcon} />   Mark  All as Read
            {settingAsRead && <CircularProgress className={clsx(classes.circularProgressIcon,classes.addMargintoLeft)} />}
          </MenuItem>
        </Menu>

        {!usePopup && 
          <Drawer variant="persistent" key="messages" anchor="right" open={this.state.open || redirectMessageOpen || (editing ? true : false)}>
            <Messages
              {...this.props}
              open={this.state.open || redirectMessageOpen}
              onClose={this.handleClose}
              showUnreadOnly={showUnreadOnly}
              orgRuntime={orgRuntime}
            />
          </Drawer>
        }

        {usePopup && 
          
            <Modal
              className={classes.popupwindow}
              open={this.state.open || (editing ? true : false)}
              onClose={(event, reason)=>{
                if(reason === "backdropClick" || reason === "escapeKeyDown"){
                  event.preventDefault();
                  event.stopPropagation();
                }else{
                  this.handleClose();
                }
              }}
              aria-labelledby="messageHeader"
            >
              <Messages
                {...this.props}
                open={this.state.open}
                onClose={this.handleClose}
                orgRuntime={orgRuntime}
              />
            </Modal>
           
        }

      </>
    );
  }
}

const mapStateToProps = (state) => ({
  messages: state.messages,
  inbox: state.inbox,
  user: state.user,
  orgRuntime: state.orgRuntime,
});

export default connect(mapStateToProps, {
  setNewCount,
  setUnreadCount,
  editMessage,
  setEditMessageCB,
  closeMessageCB,
  postMessage,
  setQuery,
  selectItems,
  focusItem,
  search,
  setMessageAsRead,
  getAllUsers,
  getAllGroups,
  cloudCloseTrack,
  cloudCloseAlbum,
  updateContentReqStatus ,
  validateCR,
  setUsePopup,
  removeHistory,
  sharedPlaylistRequest,
  setPlaylistPermittedOrgs,
  redirectMessageClose
})(withStyles(styles)(withRouter(MessagesWrap)));
